import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import svTranslation from "./locales/sv/translation.json";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  sv: {
    translation: svTranslation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "sv",
    fallbackLng: "sv",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Order and from where user language should be detected
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
      ],
    },
  });

export default i18n;
